import type { Condition } from "@/types";

/**
 * Defines what Roboto resources can query events.
 */
export type EventQueryScope =
  | { type: "collection"; id: string }
  | { type: "dataset"; id: string }
  | { type: "org" }
  | { type: "session"; id: string };

export function eventScopeToCondition(
  scope: EventQueryScope,
): Condition | undefined {
  switch (scope.type) {
    case "collection":
      return {
        field: "collection.collection_id",
        comparator: "EQUALS",
        value: scope.id,
      };
    case "dataset":
      // TODO:
      // Dataset-scoped events are fetched via `useDatasetEvents`, which
      // hits `datasetService.getEventsForDataset` directly rather than
      // building a RoboQL query. RoboQL `EVENT_FIELDS` doesn't currently
      // expose a `dataset.dataset_id` field, so this scope only
      // participates in cache-key construction (via `scopeLists`) — it
      // contributes no condition to a `SearchQueryBody`.
      return undefined;
    case "org":
      return undefined;
    case "session":
      return { field: "session_id", comparator: "EQUALS", value: scope.id };
  }
}
